// extracted by mini-css-extract-plugin
export default {"goBack":"createConfig_goBack__wuFCq","form":"createConfig_form__RUBq5","formModalities":"createConfig_formModalities__G7XSV","formDescount":"createConfig_formDescount__g35tS"};